"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalInvestorFormSchema = void 0;
const yup = __importStar(require("yup"));
const mystake_common_sdk_1 = require("@boulevard1/mystake-common-sdk");
const enums_1 = require("../contracts/enums");
const IndividualShareholder_1 = require("./IndividualShareholder");
const MAX_FILE_SIZE = 5242880; // 5MB in bytes
const validFileExtensions = ["pdf"]; // For checking extensions
const isFileLike = (v) => v != null && typeof v === "object";
const isValidFileExtension = (file) => {
    const name = file === null || file === void 0 ? void 0 : file.name;
    if (typeof name !== "string" || !name)
        return false;
    const ext = name.split(".").pop();
    return ext != null && validFileExtensions.includes(ext.toLowerCase());
};
const fileValidationSchema = yup
    .mixed()
    .test("is-valid-type", "Not a valid PDF type", (file) => {
    if (!file || !isFileLike(file))
        return true;
    const t = file.type;
    return typeof t !== "string" ? false : t.toLowerCase() === "application/pdf";
})
    .test("is-valid-extension", "Not a valid PDF file", (file) => {
    if (!file || !isFileLike(file))
        return true;
    return isValidFileExtension(file);
})
    .test("is-valid-size", "Maximum file size allowed is 5MB", (file) => {
    if (!file || !isFileLike(file))
        return true;
    const s = file.size;
    return typeof s !== "number" ? false : s <= MAX_FILE_SIZE;
});
exports.ExternalInvestorFormSchema = IndividualShareholder_1.ShareholderFormSchema.shape({
    investorType: yup.string().default(enums_1.InvestorType.SOPHISTICATED),
    investorCertificate: yup
        .mixed()
        .test("is-valid-type", "Not a valid PDF type", (file) => {
        if (!file || !isFileLike(file))
            return true;
        const t = file.type;
        return typeof t !== "string" ? false : t.toLowerCase() === "application/pdf";
    })
        .test("is-valid-extension", "Not a valid PDF file", (file) => {
        if (!file || !isFileLike(file))
            return true;
        return isValidFileExtension(file);
    })
        .test("is-valid-size", "Maximum file size allowed is 5MB", (file) => {
        if (!file || !isFileLike(file))
            return true;
        const s = file.size;
        return typeof s !== "number" ? false : s <= MAX_FILE_SIZE;
    }),
    certificateExpiryDate: yup.date(),
    companyExtract: fileValidationSchema,
    structureDiagram: fileValidationSchema.when("ownerType", {
        is: (ownerType) => typeof ownerType === "string" && ownerType.toLowerCase() === mystake_common_sdk_1.OwnerType.COMPANY.toLowerCase(),
        then: (schema) => schema.required("Structure diagram is required"),
        otherwise: (schema) => schema,
    }),
    officeHolders: yup.array().of(yup.object().shape({
        firstName: yup.string().required("First name is required"),
        middleName: yup.string(),
        lastName: yup.string().required("Last name is required"),
        role: yup.string().required("Role is required"),
        email: yup.string().email("Invalid email").required("Email is required"),
        dateOfBirth: yup.string().required("Date of birth is required"),
        isKYCVerified: yup.boolean(),
        kycVerifiedDate: yup.date(),
    })),
    officeHoldersAddresses: yup.array().of(yup.mixed()),
    ultimateBeneficialOwners: yup.array().of(yup.object().shape({
        firstName: yup.string().required("First name is required"),
        middleName: yup.string(),
        lastName: yup.string().required("Last name is required"),
        percentageHeld: yup.number().min(0).max(100).required("Percentage held is required"),
        email: yup.string().email("Invalid email").required("Email is required"),
        dateOfBirth: yup.string().required("Date of birth is required"),
        isKYCVerified: yup.boolean(),
        kycVerifiedDate: yup.date(),
    })),
    ultimateBeneficialOwnersAddresses: yup.array().of(yup.mixed()),
});
//# sourceMappingURL=ExternalInvestorSchema.js.map